var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditTreatment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29141 0.525146H5.31641C2.83112 0.525146 0.816406 2.53986 0.816406 5.02514V8.97515C0.816406 11.4604 2.83112 13.4751 5.3164 13.4751H9.26641C11.7517 13.4751 13.7664 11.4604 13.7664 8.97515V7.00015",
    stroke: "#213332",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59481 1.5468C10.4491 0.692524 11.8341 0.692524 12.6884 1.5468V1.5468C13.5427 2.40107 13.5427 3.78612 12.6884 4.64039L7.8133 9.51548C7.56518 9.76361 7.23791 9.91689 6.88845 9.94866L5.81895 10.0459C4.88604 10.1307 4.1045 9.34915 4.1893 8.41625L4.28653 7.34675C4.3183 6.99728 4.47158 6.67002 4.71971 6.42189L9.59481 1.5468Z",
    stroke: "#213332"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0415 2.1875V2.1875C9.60026 3.58439 10.7071 4.69124 12.104 5.25V5.25",
    stroke: "#213332",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTreatment);
export default __webpack_public_path__ + "static/media/edit_treatment.c79ea583c10df5d03532f26d4b466833.svg";
export { ForwardRef as ReactComponent };